export const NUMBER_INPUT_FOR_CONCURRENT_REQUEST = 1;
export const QUANTITY_IMAGE = 1;
export const DOWNLOAD_MARGIN_TOP = "-6px";
export const DOWNLOAD_BLACKBOARD_CLASS = "download-blackboard";
export const DOWNLOAD_KEYNOTE_CLASS = "download-keynote";
